import styled from 'styled-components';

import { baseColor, primaryColor } from 'views/services/color-scheme';

export const Map = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const Information = styled.div`
  position: absolute;
  left: 10px;
  bottom: 24px;
  width: 400px;
  background-color: ${baseColor};
  border-left: 8px solid ${primaryColor};
  border-radius: 0 8px 8px 0;
  padding: 16px;
  box-shadow: 0 1px 12px -8px black;
  & > dl {
    display: flex;
    flex-wrap: wrap;
    & > dt {
      flex-basis: 15%;
    }
    & > dd {
      flex-basis: 85%;
      & > a {
        color: ${primaryColor};
        text-decoration: underline;
        &:hover {
          opacity: 0.75;
        }
      }
    }
  }
`;
